<template>
  <div style="display: none;" />
</template>

<script>
export default {
  name: 'AddThisWrapper',
  props: {
    shareTitle: { type: String, required: true },
    widgetId: { type: String, required: true },
  },
  data() {
    return {
      baseUrl: '//s7.addthis.com/js/300/addthis_widget.js#pubid=',
    }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
  },
  watch: {
    currentLocale() {
      window.addthis_share.title = this.$t('addThisConfig.shareTitle')
    },
  },
  created() {
    const scriptTag = document.createElement('script')

    window.addthis_share = {
      clear: true,
      title: this.$t('addThisConfig.shareTitle'),
      url: window.location.origin,
    }

    scriptTag.setAttribute('src', `${this.baseUrl}${this.widgetId}`)
    document.body.appendChild(scriptTag)
  },
  mounted() {
    this.destroyEl()
  },
  methods: {
    destroyEl() {
      this.$el.parentNode.removeChild(this.$el)
    },
  },
}
</script>
